import { Link, useLocation } from "react-router-dom";

import { Empty, Panel } from "../components/Panel";

export function NotFound() {
  const { pathname } = useLocation();
  return (
    <Panel title="Страница не найдена">
      <Empty>
        <span className="num">{pathname}</span> — такого раздела нет.{" "}
        <Link to="/" className="underline">
          вернуться к списку рынков
        </Link>
      </Empty>
    </Panel>
  );
}
